import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from "@mui/material";

const OneTimePaymentModal = ({ open, onClose, onConfirm, selectedPlan }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        elevation: 24,
      }}
    >
      <DialogTitle sx={{ fontSize: 24, fontWeight: 600, pt: 3, color: (theme) => theme.palette.text.primary }}>
        One-Time Cost
      </DialogTitle>

      <DialogContent>
        <Box sx={{ py: 1 }}>
          <Typography variant="body1" sx={{ mb: 2, color: (theme) => theme.palette.text.primary }}>
            Would you like to add-on New User Implementation?
          </Typography>

          <Typography variant="body1" sx={{ color: (theme) => theme.palette.text.primary }}>
            This is a one-time cost of 
            <Box component="span" sx={{ fontWeight: 600, color: (theme) => theme.palette.text.primary }}>
              {" "} $1,000 USD
            </Box>.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
        <Button
          variant="outlined"
          onClick={() => onConfirm(false)}
          sx={{ minWidth: 100 }}
          className="glass-button-secondary-50"
        >
          No, Skip
        </Button>

        <Button
          variant="contained"
          onClick={() => onConfirm(true)}
          color="primary"
          sx={{ minWidth: 100 }}
        >
          Yes, Add Implementation
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OneTimePaymentModal;
